import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";
import Img1 from "../../images/referral-program/promote-1.png";

function Promote(props) {
    return (
        <div className="ref-promote p-100">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="ref-promo-content">
                            <h2>Why Promote Tekrevol’s Services?</h2>
                            <p>Our referral partners are already earning thousands of dollars each month by just sending us leads that get converted. Jump in on this incredibly lucrative bandwagon today!</p>
                            <ul>
                                <li>Award Winning App Development Services</li>
                                <li>Incredible Client/Lead Conversion Rates</li>
                                <li>Higher, Bigger and Better Commissions</li>
                                <li>Almost Immediate Payouts</li>
                                <li>Wide Range Of Service</li>
                            </ul>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="ref-promo-img">
                            <LazyLoadImage
                                src={Img1}
                                effect="blur" alt="promote" className="img-fluid"
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Promote;